import { CurrencyEnums } from "models/enums";
import EnumHelper from "./enumHelper";
import { LocalizationHelperInstance } from "utils/helpers";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { CurrencyCode } from "models/enums/currency";

const CurrencyHelper = {
  getCurrencyCodeList: () => {
    return EnumHelper.getItemKeys(CurrencyEnums.CurrencyCode);
  },

  getSuggestedCurrencyList: () => {
    const commonCurrencyCodes = [
      CurrencyEnums.CurrencyCode.SEK,
      CurrencyEnums.CurrencyCode.USD,
      CurrencyEnums.CurrencyCode.EUR,
      CurrencyEnums.CurrencyCode.NOK,
      CurrencyEnums.CurrencyCode.GBP,
    ];

    return commonCurrencyCodes.map((c) => c.toString());
  },

  getFormattedCurrencyInSEK: (amount: number) => {
    return LocalizationHelperInstance.getFormattedCurrency(amount, CurrencyEnums.CurrencyCode.SEK);
  },

  getSummaryToPrintWithSum: (
    sumValue?: number | WintSuperkollAPIModel.CurrencyValue,
    breakdown?: WintSuperkollAPIModel.CurrencyValue[] | undefined
  ) => {
    if (breakdown?.length === 1 && breakdown[0].type === CurrencyEnums.CurrencyCode.SEK) {
      return breakdown;
    }

    const valueInSEK = typeof sumValue === "number" ? sumValue : sumValue?.value;
    return [
      `[${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Summation)}: ${
        valueInSEK !== undefined
          ? LocalizationHelperInstance.getFormattedCurrency(valueInSEK, CurrencyEnums.CurrencyCode.SEK, 0, 2)
          : ``
      }]`,
      ...(breakdown ?? []),
    ];
  },

  toRoundedDownSEK: (amount: number) => {
    const displayAmount = Math.floor(amount);
    return LocalizationHelperInstance.getFormattedCurrency(displayAmount, CurrencyCode.SEK, 0, 0);
  },

  toRoundedDownNearestThousand: (amount: number) => {
    return Math.floor(amount / 1000) * 1000;
  },
};
export default CurrencyHelper;
